export default __webpack_public_path__ + "static/media/carouselChevron.13ff4816.svg";